// ABOUTME: One place decides who still owes the onboarding form and who is done with it.
// ABOUTME: Dashboard sends people in; the /onboarding route sends the finished ones back out.

/** The only part of `Me` this decision needs. */
interface OnboardingSubject {
  /** `undefined` means "not loaded yet" — a cache miss, not an answer. */
  isOnboardingFilled: boolean | null | undefined
  isCoach: boolean
}

/** Coaches never owe onboarding: finishing it is how one becomes a coach. */
const isCoachHere = (me: OnboardingSubject, isCoachRole: boolean) => isCoachRole || me.isCoach

export const needsOnboarding = (me: OnboardingSubject, isCoachRole: boolean): boolean => {
  if (isCoachHere(me, isCoachRole)) return false

  return me.isOnboardingFilled === false || me.isOnboardingFilled === null
}

export const hasFinishedOnboarding = (me: OnboardingSubject, isCoachRole: boolean): boolean => {
  if (isCoachHere(me, isCoachRole)) return true

  return me.isOnboardingFilled === true
}
